<app-spinner name="request-new-role"></app-spinner>

<div>
  @if (showErrorMessage) {
    <app-alert [message]="showErrorMessage" [msgtype]="'error'" [messageHeading]="'Error'"></app-alert>
  }
</div>

@if (!isRequestSuccess) {
  <div>
    <app-multi-org-filter-ta pageType="add-role" [showRequired]="true" [showSelectRoles]="true" (onOrgChange)="onOrgChange($event)"></app-multi-org-filter-ta>
    <div class="mtb-20">
      <h3>Request New Role</h3>
    </div>
    <app-role-information (onCartChange)="onCartChange($event)"></app-role-information>
    <div class="container flex mobile border-top border-gray-600 mt-20 pt-10">
      <span class="basis-50">
        <span class="flex justify-start">
          <button [routerLink]="['..']" class="secondary border-red rounded-4 hover-red hover-font-white flex-row-reverse mobile">
            <div class="btn-txt font-red bold">Back</div>
          </button>
        </span>
      </span>
      <span class="basis-50">
        <span class="flex justify-end">
          <button class="rounded-4 hover-blue-800 black mobile" (click)="submitRoleRequest()" [class.disabled]="!rolesOnCart?.length">
            <div class="btn-txt font-white bold">Submit Role Request</div>
          </button>
        </span>
      </span>
    </div>
  </div>
}

@if (isRequestSuccess) {
  <app-role-request-success message="Your role request actions were processed."></app-role-request-success>
}
